import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Mail, Linkedin, Heart, Coffee } from 'lucide-react';
import FAQ from '@/components/FAQ';
import { useTranslation } from '@/hooks/useTranslation';
const Footer: React.FC = () => {
  const {
    t
  } = useTranslation();
  return <footer className="bg-muted/30 border-t border-border mt-20">
      <div className="max-w-6xl mx-auto px-6 py-16">

        {/* Project philosophy */}
        

        {/* FAQ Section */}
        <FAQ />

        {/* Bottom section */}
        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-2 text-muted-foreground">
              <span>{t('madeWithLove')}</span>
              <Heart className="w-4 h-4 text-red-500" />
              <span>{t('culturalExploration')}</span>
            </div>
            
            <div className="flex items-center gap-6">
              <a href="https://www.linkedin.com/in/francois-pineau-a93ba41ba/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors p-2 hover:scale-110 transition-transform" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              
              <nav className="flex gap-4 text-sm">
                <a href="/blog" className="text-muted-foreground hover:text-foreground transition-colors">
                  Blog
                </a>
                <a href="/sitemap" className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('sitemap')}
                </a>
                <a href="/mentions-legales" className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('legalNotice')}
                </a>
                <a href="/auth" className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('logIn')}
                </a>
                
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;